import axios from '@/utils/api'

export const checkEmailDomain = ({ commit, state, dispatch, getters }, domain) => {
  commit('CHANGE_PREDICTED_EMAIL_DOMAIN', '')
  axios({
    method: 'GET',
    url: `${state.backendUrl}/check/domain/${domain}`,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    const predict = response.data.data.predict_domain
    if (predict && predict !== domain) {
      commit('CHANGE_PREDICTED_EMAIL_DOMAIN', predict)
      let emailLS = localStorage.getItem('emailHistory')
      localStorage.setItem('emailHistory', emailLS + JSON.stringify([domain, predict]))
      localStorage.setItem('domain', predict)

      if (state.method === '/form') {
        let temp = state.history
        for (let i in temp) {
          if (temp[i].name === 'email') {
            console.log('before replacing:', temp[i].value)
            temp[i].value = temp[i].value.split('@')[0] + '@' + predict
            console.log('after replacing:', temp[i].value)
          }
        }
        commit('CHANGE_HISTORY', temp)
      }
    } else {
      commit('CHANGE_PREDICTED_EMAIL_DOMAIN', '')
    }
  })
}

export const autocompleteFieldsWithJWT = ({ state, commit, getters, dispatch }) => {
  commit('CHANGE_METHOD', '/process')
  commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: 'on' })
  let temp = JSON.parse(JSON.stringify(state.authHistory))
  for (let step in temp) {
    temp[step].value = temp[step].value || state.JWTAutocomplete[temp[step].name]
    if (temp[step].name === 'phone' && temp[step].value && !temp[step].value.includes('+')) {
      temp[step].value = `+${temp[step].value}`
    }
    temp[step].field = getters.getFieldInfoByName(temp[step].name)
    temp[step].isValid = true
    if (temp[step].name === 'surname' || temp[step].name === 'surname_second') temp[step].skip = true
    if (temp[step].name === 'surname_second' && !temp[step].value) temp[step].value = ''
  }
  commit('CHANGE_HISTORY', temp)
  commit('CHANGE_STEP', Object.keys(temp).length - 1)
  dispatch('pushGAEvent', { event: 'FirstStepSubmitted', state: 'authorised' })
  dispatch('pushFBEvent', {
    track: 'track',
    event: 'Lead',
    data: {status: localStorage.getItem('lead_status')}
  })
  dispatch('initGAHistory', true)
  commit('UPDATE_PERCENTS', 30)
  // commit('SHOW_AUTH_TEXT', true)
}

export const autocompleteFieldsWithData = ({ commit, state, dispatch, getters }, data) => {
  const lead_id = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  commit('CHANGE_ADDITIONAL_PARAMS', {lead_id, is_terms_accepted: 'on'})
  commit('CHANGE_METHOD', '/process')
  const ordering = state.config.main_fields.sort((a, b) => ((a.order < b.order) ? -1 : (a.order > b.order) ? 1 : 0)).map(x => x.name)
  const lpPos = ordering.indexOf('loan_purpose')
  if (lpPos > -1) {
    ordering.splice(lpPos, 1)
    ordering.unshift('loan_purpose')
  }
  const AutocompletedHistory = {}
  let step = 0
  for (const i in ordering) {
    const name = ordering[i]
    let value = data[name]
    if (name === 'loan_sum' && !value) value = localStorage.getItem(name)
    if (value !== null && value !== undefined && value !== 0) {
      if (name === 'phone') value = '+' + value
      AutocompletedHistory[step] = {
        name: name,
        value: value,
        field: getters.getFieldInfoByName(name),
        isValid: true,
        skip: ['phone'].indexOf(name) === -1
      }
      step += 1
    }
  }
  commit('CHANGE_HISTORY', AutocompletedHistory)
  commit('CHANGE_STEP', step - 1)
  if (window.location.hostname !== 'localhost') {
    // PUSH PROCESS
    dispatch('nextStepPrepare', +1)
  } else {
    console.log('%c 🤚 DON\'T AUTOSEND PROCESS ON localhost (after AUTH, because loop). Now you see last field in history', 'color: violet; background: black')
  }
  dispatch('pushGAEvent', { event: 'FirstStepSubmitted', state: 'authorised' })
  dispatch('pushFBEvent', {
    track: 'track',
    event: 'Lead',
    data: {status: localStorage.getItem('lead_status')}
  })
  dispatch('initGAHistory', true)
  commit('UPDATE_PERCENTS', 30)
  // commit('SHOW_AUTH_TEXT', true)
}

export const getCustomerToken = ({ commit, state, dispatch, getters }, initiator) => {
  return new Promise((resolve, reject) => {
    let formData = new FormData()
    formData.set('lead_id', state.additionalParams.lead_id)
    axios({
      method: 'POST',
      url: `${state.backendUrl}/customer/token`,
      data: formData,
      headers: {'Content-Type': 'application/json'}
    }).then((response) => {
      // commit('CHANGE_PRELOADER', false)
      resolve(response.data.data)
    }, (error) => {
      console.log(error.response)
      reject(error)
    })
  })
}

export const getCheckboxes = ({ commit, state, dispatch, getters }, leadId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: `${state.backendUrl}/agreements?lead_id=${leadId}`,
      headers: {'Content-Type': 'application/json'}
    }).then((response) => {
      resolve(response.data.data)
    }, (error) => {
      console.log(error.response)
      reject(error)
    })
  })
}

export const getAgreements = ({ commit, state, dispatch, getters }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: `${state.backendUrl}/advertiser_agreement?country_id=${state.additionalParams.country}`,
      headers: {'Content-Type': 'application/json'}
    }).then((response) => {
      resolve(response.data.data)
    }, (error) => {
      console.log(error.response)
      reject(error)
    })
  })
}

export const initializeJuicyScore = ({ commit, state, dispatch, getters }) => {
  const juicyUrl = state.isDev ? 'https://score.juicyscore.net/static/js.js' : 'https://score.juicyscore.com/static/js.js'
  window.juicyLabConfig = {
    nextButton: '.form-buttons__next'
  }
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = juicyUrl
  s.onload = getJuicyScoreSession
  const x = document.getElementsByTagName('head')[0]
  x.appendChild(s)

  function getJuicyScoreSession () {
    try {
      window.juicyScoreApi.getSessionId().then(
        function (s) {
          localStorage.setItem('juicescore_session_id', s)
        }
      )
    } catch (e) { console.log('problems with juicyscore init') }
  }
}

export const insertOrUpdateField = ({ commit, state, dispatch, getters }, params) => {
  // convert history dict to array and find field if already exist
  let result = []
  for (let i in state.history) {
    if (state.history[i].name === params.data.name) {
      // merge with old data, and not insert to array
      params.data = {...state.history[i], ...params.data}

      // WARN, this is logic for moving existing fields. we need to do step backward
      // TODO: test it in cases with validation etc.
      if (i <= state.currentStep && state.currentStep > 0) {
        console.warn(`our case. Name: ${params.data.name} history: ${i}, curr: ${state.currentStep}, to: ${params.index}`)
        state.currentStep -= 1
      }

      // if field in previous steps we will move it, so current step will change to -1, and we will need to insert this field to needle index - 1
      // if (i < state.currentStep) params.index -= 1
    } else {
      result.push(state.history[i])
    }
  }
  // insert new or updated field to pos (IF !deleteStep)
  if (!params.deleteStep) {
    // call splice to insert field to index
    result.splice(params.index, 0, params.data)
  } else {
    console.log(`delete "${params.data.name}"`)
  }

  let resultDict = {}
  for (let i in result) resultDict[i] = result[i]

  commit('CHANGE_HISTORY', resultDict)
}

export const callSimpleAuth = ({ commit, state, dispatch, getters }, incr) => {
  commit('CHANGE_PRELOADER', true)
  window.hybridAuthAlreadySended = true
  let formData = new FormData()
  for (let i in state.additionalParams) {
    if (i !== 'lead_id') formData.set(i, state.additionalParams[i])
  }
  formData.set('loan_sum', getters.getFieldValue('loan_sum'))
  formData.set('loan_period', getters.getFieldValue('loan_period'))
  formData.set('phone', getters.getFieldValue('phone'))
  axios({
    method: 'POST',
    url: state.backendUrl + '/simple-auth',
    data: formData
  }).then((response) => {
    commit('CHANGE_PRELOADER', false)
    commit('CHANGE_ADDITIONAL_PARAMS', { lead_id: response.data.data.lead_id })
    commit('CHANGE_LEAD_STATUS', response.data.data.lead_status)
    dispatch('autocompleteFieldsWithData', response.data.data.customer)
  }, (response) => {
    commit('CHANGE_PRELOADER', false)
    console.log('simple Auth - unsuccessfull (((, go to the next fields')
    dispatch('initGAHistory', false)
    dispatch('changeStep', incr)
  })
}



// WEBPACK FOOTER //
// ./src/store/helpers/helpers-actions.js